/**
 * Archivo de índice para exportar todos los componentes, hooks y utilidades
 * de EditarEvaluacion de forma organizada
 */

// Componente principal - usando el archivo .jsx nuevo
import EditarEvaluacionComponent from './EditarEvaluacion.jsx';
export { EditarEvaluacionComponent as EditarEvaluacion };
export default EditarEvaluacionComponent;

// Componentes de pasos
export { default as Step1InformacionBasica } from './Steps/Step1InformacionBasica/Step1InformacionBasica.jsx';
export { default as Step2Configuracion } from './Steps/Step2Configuracion/Step2Configuracion.jsx';
export { default as Step3Preguntas } from './Steps/Step3Preguntas/Step3Preguntas.jsx';
export { default as Step4Revision } from './Steps/Step4Revision/Step4Revision.jsx';

// Componentes de UI reutilizables
export { default as StepIndicator } from './UI/StepIndicator.jsx';
export { default as NavigationButtons } from './UI/NavigationButtons.jsx';
export { default as CargosMultiselect } from './UI/CargosMultiselect.jsx';
export { default as ToggleSwitch } from './UI/ToggleSwitch.jsx';
export { LoadingState, ErrorState } from './UI/StateComponents.jsx';

// Hooks customizados
export { default as useEvaluacionForm } from './Hooks/useEvaluacionForm.js';
export { default as useEvaluacionValidation } from './Hooks/useEvaluacionValidation.js';

// Utilidades y helpers
export * from './Utils/dataMappers.js';
export * from './Utils/constants.js';